import { Component, OnInit } from '@angular/core';
import { SectionsService } from '../../_services/sections.service';
import { AppConstants } from '../../app.constants';

@Component({
	selector: 'section-transition',
	templateUrl: './section-transition.component.html',
	styleUrls: ['./section-transition.component.scss'],
	host: {'class': 'section-transition'}
})
export class SectionTransitionComponent implements OnInit {

	public sections;
	public activeSection;
	public sectionContentAll = [];
	public activeSectionPosition;
	public sectionPosBefore;
	public isFirstAnim = true;
	public isAnimated = false;
	public animation;

	constructor(private _sectionsService: SectionsService) {
		//let sectionContentAll = this._sectionsService.getCurrentSectionContent();
		let sectionPosition = this._sectionsService.getCurrentSectionPosition();
		let newSectionCarousel = [];

		let constants = [
			AppConstants.sectionExploration,
			AppConstants.sectionCity,
			AppConstants.sectionPopCulture,
			AppConstants.sectionInnovation
		]

		let sectionContentAll = constants[sectionPosition];

		var j = 0;
		for(var i = 0; i < sectionContentAll.length; i++){
			if(sectionContentAll[i].scrollContent){
				for(var k = 0; k < sectionContentAll[i].scrollContent.length; k++){
					if(sectionContentAll[i].scrollContent[k].type != "video"){
						newSectionCarousel.push(sectionContentAll[i].scrollContent[k])	
						newSectionCarousel[j]._id = j;
						j++;
					}
				}
				
			}
			else{
				newSectionCarousel.push(sectionContentAll[i])	
				newSectionCarousel[j]._id = j;
				j++;
			}
		}
		this.sectionContentAll = newSectionCarousel;
	}

	ngOnInit() {


		this.sections = this._sectionsService.getSections();
		this.activeSectionPosition = this._sectionsService.getCurrentSectionPosition();

		this.sectionPosBefore = this.activeSectionPosition;
		/*this._sectionsService.changeSection.subscribe(sectionPos => {
			this.activeSectionPosition = sectionPos;
			this.activeSection = this.sections.find(data => data.position === this.activeSectionPosition);
			if(!this.isFirstAnim){
				this.isAnimated = true;
				if(this.sectionPosBefore > this.activeSectionPosition){
					this.animation = 'down';
				}
				else{
					this.animation = 'up';
				}
				this.sectionPosBefore = this.activeSectionPosition;

				setTimeout(() => {
					this.isAnimated = false;
					this.animation = '';
				}, 4400)
			}
		});

		this._sectionsService.changesectionContentAll.subscribe(sectionContentAll => {
			this.sectionContentAll = sectionContentAll;
		})

		*/

		this.activeSectionPosition = this._sectionsService.getCurrentSectionPosition();
		this.activeSection = this.sections.find(data => data.position === this.activeSectionPosition);

		this.isAnimated = true;
		if(this.sectionPosBefore > this.activeSectionPosition){
			//this.animation = 'left';
		}
		else{
			this.animation = 'left';
		}
		this.sectionPosBefore = this.activeSectionPosition;

		setTimeout(() => {
			this.isAnimated = false;
			this.animation = '';
		}, 4400)

		//this.sectionContentAll = this._sectionsService.getCurrentsectionContent();


	}

	goDown(sectionPosBefore, sectionPosAfter){
		if(sectionPosBefore > sectionPosAfter){
			//exemple: 2018 -> 2017
			return true;
		}
		else{
			return false
		}
	}

}
